/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./QrGen.vue?vue&type=template&id=34aac4be&scoped=true&"
import script from "./QrGen.vue?vue&type=script&setup=true&lang=js&"
export * from "./QrGen.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./QrGen.vue?vue&type=style&index=0&id=34aac4be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aac4be",
  null
  
)

export default component.exports